// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from '@rails/actioncable'
// Deep import on purpose: the package root defines <turbo-cable-stream-source> on evaluation, which
// upgrades elements already in the (deferred-script) DOM and calls getConsumer() before we could
// register. Without a registered consumer turbo-rails lazy-loads a second ActionCable copy as a
// separate webpack chunk, and when that chunk fails to load, turbo_stream_from stops receiving.
import { setConsumer } from '@hotwired/turbo-rails/app/javascript/turbo/cable'

const consumer = createConsumer()
setConsumer(consumer)

export default consumer
